import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    console.log("Filter form controller connected")
    console.log("Form element:", this.element)
    console.log("Form ID:", this.element.id)

    // Listen for changes on hidden inputs created by SelectMulti components
    this.element.addEventListener('change', this.handleFilterChange.bind(this))

    // Also listen for input events
    this.element.addEventListener('input', this.handleFilterChange.bind(this))

    // Specifically listen for changes on SelectMulti hidden inputs
    this.setupSelectMultiListeners()
  }

  setupSelectMultiListeners() {
    // Find all SelectMulti components within this form
    const selectMultiElements = this.element.querySelectorAll('[data-controller*="uikit--select-multi"]')
    console.log("Found SelectMulti elements:", selectMultiElements.length)

    // Also log all elements with data-controller to see what's available
    const allControllers = this.element.querySelectorAll('[data-controller]')
    console.log("All elements with data-controller:", allControllers.length)
    allControllers.forEach((el, i) => {
      console.log(`Controller ${i}:`, el.getAttribute('data-controller'))
    })

    selectMultiElements.forEach((selectMultiElement, index) => {
      console.log(`Setting up listener for SelectMulti ${index}:`, selectMultiElement)

      // Listen for changes on the hidden input
      const hiddenInput = selectMultiElement.querySelector('input[type="hidden"][data-main-input="true"]')
      if (hiddenInput) {
        console.log(`Found hidden input for SelectMulti ${index}:`, hiddenInput.name)
        hiddenInput.addEventListener('change', (event) => {
          console.log(`SelectMulti ${index} hidden input changed:`, event.target.name, event.target.value)
          this.handleFilterChange(event)
        })
      } else {
        console.warn(`No hidden input found for SelectMulti ${index}`)
      }
    })
  }

  handleFilterChange(event) {
    // Only handle changes on filter-related inputs
    if (event.target.name && event.target.name.includes('filter_')) {
      console.log("Filter change detected:", event.target.name, event.target.value)

      // Add a small delay to allow the select component to update its values
      setTimeout(() => {
        this.submitForm()
      }, 100)
    }
  }

  submitForm() {
    console.log("Submitting filter form with Turbo Frame")

    // Get the form element
    const form = this.element
    console.log("Form element for submission:", form)

    // Build the query string
    const params = new URLSearchParams()

    // Get selected values directly from SelectMulti components
    const selectMultiElements = form.querySelectorAll('[data-controller*="uikit--select-multi"]')
    console.log("Found SelectMulti elements:", selectMultiElements.length)

    selectMultiElements.forEach((selectMultiElement) => {
      // Get the SelectMulti controller
      const selectMultiController = this.application.getControllerForElementAndIdentifier(
        selectMultiElement,
        'uikit--select-multi'
      )

      if (selectMultiController) {
        const selectedValues = selectMultiController.getSelectedValues()
        const inputName = selectMultiElement.querySelector('input[type="hidden"][data-main-input="true"]')?.name

        console.log(`SelectMulti ${inputName} selected values:`, selectedValues)

        if (inputName && selectedValues.length > 0) {
          selectedValues.forEach(value => {
            params.append(inputName, value)
          })
        }
      }
    })

    // Also collect any other form data (non-SelectMulti inputs)
    const formData = new FormData(form)
    for (let [key, value] of formData.entries()) {
      // Skip SelectMulti inputs as we've already handled them
      if (!key.includes('filter_') || !selectMultiElements.length) {
        if (value && value.trim() !== '') {
          params.append(key, value.trim())
        }
      }
    }

    // Preserve existing URL parameters that are not filter-related
    const currentUrl = new URL(window.location)
    const currentParams = currentUrl.searchParams

    for (let [key, value] of currentParams.entries()) {
      if (!key.startsWith('filter_') && key !== 'page') {
        params.append(key, value)
      }
    }

    // Preserve the status parameter to maintain the current tab
    const currentStatus = currentParams.get('status')
    if (currentStatus) {
      params.set('status', currentStatus)
    }

    // Build the new URL
    const newUrl = `${currentUrl.pathname}?${params.toString()}`

    // Use Turbo Frame to update only the orders table
    const turboFrame = document.querySelector('turbo-frame#orders-table')
    if (turboFrame) {
      // Update the browser URL first
      window.history.pushState({}, '', newUrl)

      // Update the Turbo Frame source to trigger a Turbo Frame request
      turboFrame.src = newUrl
    } else {
      console.warn("Turbo Frame not found, falling back to full page reload")
      // Fallback to full page reload if Turbo Frame is not available
      window.location.href = newUrl
    }
  }
}
